import React from "react";

import "./ServicesLanding.css";

const servicios = [
    { id: 1, titulo: "Gestión Integral de Inversiones Inmobiliarias", subtitulo: "Optimizamos tus inversiones con análisis de mercado estratégicos y una gestión personalizada para asegurar la máxima rentabilidad." },
    { id: 2, titulo: "Consultoría Estratégica Jurídica Inmobiliaria", subtitulo: "Ofrecemos asesoramiento legal especializado en transacciones internacionales, supervisando cada detalle de la documentación para tu tranquilidad." },
    { id: 3, titulo: "Networking Internacional", subtitulo: "Conectamos a inversores y desarrolladores con oportunidades clave en los mercados globales más importantes." },
    { id: 4, titulo: "Soporte Estratégico para Fondos Comunes de Inversión", subtitulo: "Te guiamos en la creación y gestión de fondos de inversión, asegurando estructuras legales y fiscales eficientes y rentables." },
];

const ServicesLanding = () => {
  return (
    <section className="services-landing-container">
      <h2 className="services-landing-title">
        Impulsa tus Inversiones con la ayuda de expertos: Conoce Nuestros Servicios
      </h2>
      <h3 className="services-landing-subtitle">
        Desde el primer acercamiento, Thorne Global te ofrece un soporte completo para que invertir en Dubái sea sencillo y exitoso.
      </h3>
      <div className="services-landing-grid">
        {servicios.map((servicio, index) => (
            <div key={index} className="service-landing-item">
                <h4 className="service-landing-title">{servicio.titulo}</h4>
                <p className="service-landing-description">{servicio.subtitulo}</p>
            </div>
        ))}
      </div>
    </section>
  )
};

export default ServicesLanding;